import React from 'react';
import { NavLink } from 'react-router-dom';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
// import { useTranslation } from 'jsx/hooks/useTranslation';
// import useProductBreads from 'jsx/hooks/useProductBreads';

export default ({ products = [], options }) => {
  // const { t } = useTranslation();
  // const breads = useProductBreads(products);

  let breadOptions = options || {};
  const breadcrumbs = useBreadcrumbs(products, breadOptions || []);
  return (
    <>
      <div className="bread-crumbs no-print">
        {breadcrumbs.map(({ match, breadcrumb }, i) => (
          <CrumbItem url={match.url} breadcrumb={breadcrumb} isSep={i < breadcrumbs.length - 1} key={i} />
        ))}
      </div>
    </>
  );
};

const CrumbItem = ({ url, breadcrumb, isSep }) => {
  return (
    <>
      <div className="bread-crumb">
        <NavLink to={url} activeClassName="current">
          {breadcrumb}
        </NavLink>
      </div>
      {isSep && <BreadCrumbSeparator />}
    </>
  );
};

const BreadCrumbSeparator = () => {
  return (
    <>
      <div className="bread-sep">/</div>
    </>
  );
};
